
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx'
import XLSXStyle from "xlsx-style";
import moment from "moment";
const setExlStyle = (data, name) => {
    let borderAll = {  //单元格外侧框线
        top: {
            style: 'thin',
        },
        bottom: {
            style: 'thin'
        },
        left: {
            style: 'thin'
        },
        right: {
            style: 'thin'
        }
    };
    data['!cols'] = [];

    for (let key in data) {
        if (name == 'list5' && (key == 'AZ1' || key == 'AZ2' || key == 'AZ11' || key.includes('12'))) {
            delete data[key];
            continue;
        }
        if (data[key] instanceof Object) {
            data[key].s = {
                border: borderAll,
                alignment: {
                    horizontal: 'center',   //水平居中对齐
                    vertical: 'center'
                },
                font: {
                    sz: 11,
                },
                bold: true,
                numFmt: 0,
                fill: {
                }
            }
            const reg = /^[A-Z]{1,2}[1]$/;
            if (reg.test(key)) {
                data[key].s.font.bold = true;
            }

            data['!cols'].push({ wpx: 115 });
        }
    }
    return data;
};


const addRangeBorder = (range, ws) => {
    let cols = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

    range.forEach(item => {
        let style = {
            s: {
                border: {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                }
            }
        }
        //处理合并行
        for (let i = item.s.c; i <= item.e.c; i++) {
            ws[`${cols[i]}${Number(item.e.r) + 1}`] = ws[`${cols[i]}${Number(item.e.r) + 1}`] || style
            // 处理合并列
            for (let k = item.s.r + 2; k <= item.e.r + 1; k++) {
                ws[cols[i] + k] = ws[cols[k] + item.e.r] || style
            }
        }
    })
    return ws;
}
export default {
    /**
     * 
     * @param {*} name  保存的表格名称
     * @param {*} tableName 页面需要导出的表格id
     * @returns 
     */
    exportExcel(name, tableName) {
        //不加判断table表格导出会有两份数据，是因为fixed造成的，所以要筛选去重
        // 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，
        let fix = document.querySelector(`#${tableName} .el-table__fixed`);
        if (fix) {
            document.getElementById(tableName).removeChild(fix);
        }
        let fixRight = document.querySelector(`#${tableName} .el-table__fixed-right`);
        if (fixRight) {
            document.getElementById(tableName).removeChild(fixRight);
        }
        let ws = XLSX.utils.table_to_sheet(document.getElementById(tableName), { raw: true })
        //创建一个workbook对象
        let wb = XLSX.utils.book_new();

        if (fix) {
            document.getElementById(tableName).appendChild(fix);
        }
        if (fixRight) {
            document.getElementById(tableName).appendChild(fixRight);
        }


        //把worksheet对象添加进workbook对象，第三个参数是excel中sheet的名字
        XLSX.utils.book_append_sheet(wb, ws, name)
        setExlStyle(wb['Sheets'][name], tableName); // 设置列宽 字号等 如果无需多余的样式则省略
        const merges = wb['Sheets'][name]['!merges'] ? wb['Sheets'][name]['!merges'] : []
        addRangeBorder(merges, wb['Sheets'][name]); //设置合并行的border
        // return
        let wb_out = XLSXStyle.write(wb, { type: 'buffer' });
        try {
            FileSaver.saveAs(new Blob([wb_out], {
                type: 'application/octet-stream'
            }), `${name}_${moment().format("YYYYMMDD")}.xlsx`);   // 导出的文件名
        } catch (e) {
            console.log(e, wb_out);
        }
        return wb_out;
    }
};
